import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Invoice } from '../models/invoice.model';
import { environment } from '@env/environment';
import { Observable, of } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
const __URL_API__ = `${environment.URL_API}`;

@Injectable({ providedIn: 'root' })
export class InvoiceService {
  private _http = inject(HttpClient);

  getAllInvoices(skip = 0, limit: number): Observable<{ count: number; data: Invoice[] }> {
    const params = new HttpParams().set('skip', skip).set('limit', limit);

    return this._http.get<{ count: number; data: Invoice[] }>(__URL_API__ + 'api/invoices', { params }).pipe(
      take(1),
      catchError((error) => {
        console.error(error);
        return of(null);
      })
    );
  }

  getDetailInvoices(filter: 'invoiceunpaid' | 'invoicepaid', skip = 0, limit?: number): Observable<{ count: number; data: Invoice[] }> {
    const params = new HttpParams().set('LeftToPayFilter', filter).set('skip', String(skip)).set('limit', String(limit));

    if (limit) {
      params.set('limit', String(limit));
    }

    return this._http.get<{ count: number; data: Invoice[] }>(__URL_API__ + 'api/invoices', { params });
  }

  getUnpaidInvoices(myfilter: string): Observable<number> {
    return this._http.get<number>(__URL_API__ + 'api/invoices/count?InDebit=false&LeftToPayFilter=' + myfilter).pipe(
      catchError((error) => {
        console.error(error);
        return of(null);
      })
    );
  }
}
